import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { StudentTokenValidationResponse } from '../../_models/student-password-generate/student-token-validation-response.model';
import { ThemeService } from '../../_helpers/theming-engine/theme.service';
import { StudentService } from '../../_services/student/student.service';
import { EmojiHelperService } from '../../_helpers/emojis/emoji-helper.service';
import { GrantStudentAccessResponse } from '../../_models/grant-student-access/grant-student-access-response.model';

@Component({
    selector: 'app-student-password-generate',
    templateUrl: './student-password-generate.component.html',
    styleUrls: ['./student-password-generate.component.css'],
    standalone: false
})
export class StudentPasswordGenerateComponent implements OnInit {

  @ViewChild("pin1", { static: false }) pin1: ElementRef;
  @ViewChild("pin2", { static: false }) pin2: ElementRef;
  @ViewChild("pin3", { static: false }) pin3: ElementRef;
  @ViewChild("pin4", { static: false }) pin4: ElementRef;

  public showGenerateErrorMessage: boolean = false;
  public generatedSuccessfully: boolean = false;
  public isNumericPin: boolean;
  public generateErrorMessage: string = "";

  public showPasswordGenerate: boolean = true;
  public showError: boolean = false;

  public errorMessage: string = "";

  private studentId: number = 0;
  private genToken: string;

  constructor(
    private route: ActivatedRoute,
    private studentService: StudentService,
    public themeService: ThemeService,
    private emojiHelper: EmojiHelperService
  ) {

  }

  ngOnInit() {
    this.themeService.setActiveTheme('LEAP', false);

    if (this.route.snapshot.queryParamMap.get('genauth') != null) {

      this.genToken = this.route.snapshot.queryParamMap.get('genauth');

      setTimeout(() => {
        this.studentService.checkToken(this.genToken).subscribe((response: StudentTokenValidationResponse) => {
          if (response != null && response.valid) {
            this.showError = false;
            this.showPasswordGenerate = true;
            this.studentId = response.studentId;
          } else {
            this.showError = true;
            this.showPasswordGenerate = false;
            this.errorMessage = response != null ? response.message : "An error has ocurred, please try again or contact your teacher if the error persists.";
          }
        },
        error => {
          this.showError = true;
          this.showPasswordGenerate = false;
          this.errorMessage = "An error has ocurred, please try again or contact your teacher if the error persists.";
        });
      }, 100);
      
    } else {
      this.showError = true;
      this.showPasswordGenerate = false;
    }
  }
  
  public generateAccess(type: string): void {
    
    this.generatedSuccessfully = false;
    this.showGenerateErrorMessage = false;

    let accessType: number = 0;
    // 1 = Guid
    // 2 = Pin
    // 3 = Emoji
    switch (type) {
      case "link":
        accessType = 1;
        break;
      case "number":
        accessType = 2;
        break;
      case "emoji":
        accessType = 3;
        break;
    }
    this.studentService.generateAccess(this.studentId, accessType, this.genToken).subscribe((grantAccessResponse: GrantStudentAccessResponse) => {

      this.generatedSuccessfully = true;

        setTimeout(() => {
          this.clearPinBoxes();

          this.isNumericPin = grantAccessResponse.isNumeric;
          if (grantAccessResponse.isNumeric) {
            this.pin1.nativeElement.innerText = grantAccessResponse.pinOne;
            this.pin2.nativeElement.innerText = grantAccessResponse.pinTwo;
            this.pin3.nativeElement.innerText = grantAccessResponse.pinThree;
            this.pin4.nativeElement.innerText = grantAccessResponse.pinFour;
          } else {
            this.pin1.nativeElement.classList.add(this.emojiHelper.getEmojiClass(grantAccessResponse.pinOne));
            this.pin2.nativeElement.classList.add(this.emojiHelper.getEmojiClass(grantAccessResponse.pinTwo));
            this.pin3.nativeElement.classList.add(this.emojiHelper.getEmojiClass(grantAccessResponse.pinThree));
            this.pin4.nativeElement.classList.add(this.emojiHelper.getEmojiClass(grantAccessResponse.pinFour));
          }
        }, 0);
        
    }, error => {
      this.showGenerateErrorMessage = true;
      console.error(error);
    });
  }

  private clearPinBoxes(): void {
    this.pin1.nativeElement.innerText = "";
    let pin1List: Array<string> = new Array<string>();
    pin1List.push(...this.pin1.nativeElement.classList);
    let pin1ClassList = pin1List.slice(0);
    pin1ClassList.forEach((className: string) => {
      if (className.indexOf("emoji") != -1 && className != "pin-box-emoji") {
        this.pin1.nativeElement.classList.remove(className);
      }
    });

    this.pin2.nativeElement.innerText = "";
    let pin2List: Array<string> = new Array<string>();
    pin2List.push(...this.pin2.nativeElement.classList);
    let pin2ClassList = pin2List.slice(0);
    pin2ClassList.forEach((className: string) => {
      if (className.indexOf("emoji") != -1 && className != "pin-box-emoji") {
        this.pin2.nativeElement.classList.remove(className);
      }
    });

    this.pin3.nativeElement.innerText = "";
    let pin3List: Array<string> = new Array<string>();
    pin3List.push(...this.pin3.nativeElement.classList);
    let pin3ClassList = pin3List.slice(0);
    pin3ClassList.forEach((className: string) => {
      if (className.indexOf("emoji") != -1 && className != "pin-box-emoji") {
        this.pin3.nativeElement.classList.remove(className);
      }
    });

    this.pin4.nativeElement.innerText = "";
    let pin4List: Array<string> = new Array<string>();
    pin4List.push(...this.pin4.nativeElement.classList);
    let pin4ClassList = pin4List.slice(0);
    pin4ClassList.forEach((className: string) => {
      if (className.indexOf("emoji") != -1 && className != "pin-box-emoji") {
        this.pin4.nativeElement.classList.remove(className);
      }
    });
  }


}
